const mediaGallery = {
  init () {

      // $('.slider-gallery').slick({
      //  slidesToShow: 1,
      //  slidesToScroll: 1,
      //  arrows: false,
      //  fade: false,
      //  asNavFor: '.slider-nav-thumbnails',
      //  draggable: false
      // });

      // $('.slider-nav-thumbnails').slick({
      //  slidesToShow: 5,
      //  slidesToScroll: 1,
      //  asNavFor: '.slider-gallery',
      //  arrows: false,
      //  dots: false,
      //  focusOnSelect: false
      // });

      let $sliderGallery =  $('.slider-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        draggable: false,
        asNavFor: '.slider-nav-thumbnails'
      });

      // let thumbCount = $('.slider-nav-thumbnails').find('.slick-slide').length;
      // let showDots = false;

      // if ( thumbCount > 5 ) {
      //   showDots = true;
      // }

      let $sliderNav =  $('.slider-nav-thumbnails').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slider-gallery',
        arrows: false,
        draggable: false,
        // infinite: true,
        // dots: showDots,
        dots: true,
        // centerMode: true,
        focusOnSelect: true
      });

      // $sliderNav.find('.slick-slide').on('click', function() {
      //   let $this = $(this);

      //   let index = $this.attr('data-slick-index');

      //   $sliderGallery.slick('slickGoTo', index);
      // });

      // Remove active class from all thumbnail slides
      // $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

      // Set active class to first thumbnail slides
      // $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

      // $('.gallery-slides').magnificPopup({
      //   delegate: 'a', // child items selector, by clicking on it popup will open
      //   type: 'image'
      //   // other options
      // });
      //
      // $('.slider--main-image').magnificPopup({
      //   type: 'image',
      //   gallery:{
      //     enabled:true
      //   }
      // });
        // $("#lightgallery").lightGallery({
        //     thumbnail:true
        // });
        //
        // $("#lightgallery").lightSlider();
      // $('.gallery-slides').slickLightbox({
      //   itemSelector        : '.slider a',
      //   navigateByKeyboard  : true
      // });

      }
  };

  export default mediaGallery;



// WEBPACK FOOTER //
// ./src/components/03-ui/43-media-gallery/43-media-gallery.js